var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_2425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8604 226.02C65.8504 246.76 96.2904 259.38 129.69 259.38C163.09 259.38 193.53 246.75 216.52 226.02H42.8604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69 0C91.5305 0 57.2105 16.49 33.4805 42.73H225.9C202.17 16.49 167.86 0 129.69 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.38 129.69C259.38 96.2305 246.71 65.7305 225.9 42.7305H33.48C12.67 65.7305 0 96.2305 0 129.69C0 167.92 16.54 202.28 42.86 226.02H216.52C242.84 202.28 259.38 167.92 259.38 129.69ZM200.87 60.2405L213.58 79.3005L226.29 98.3605L219.94 102.6L207.23 83.5405L194.52 64.4805L200.87 60.2405ZM191.34 66.5905L216.76 104.72L210.41 108.96L184.99 70.8305L191.34 66.5905ZM181.81 72.9405L194.52 92.0005L207.23 111.06L200.88 115.3L188.17 96.2405L175.46 77.1805L181.81 72.9405ZM86.49 77.1805L61.07 115.31L54.72 111.07L80.14 72.9405L86.49 77.1805ZM76.96 70.8305L51.54 108.96L45.19 104.72L70.61 66.5905L76.96 70.8305ZM61.07 60.2405L67.42 64.4805L42 102.61L35.65 98.3705L61.07 60.2405ZM61.07 208.51L35.65 170.38L42 166.14L67.42 204.27L61.07 208.51ZM70.6 202.16L57.89 183.1L45.18 164.04L51.53 159.8L64.24 178.86L76.95 197.92L70.6 202.16ZM80.13 195.81L54.71 157.68L61.06 153.44L86.48 191.57L80.13 195.81ZM169.09 159.8C155.05 180.86 126.6 186.55 105.54 172.51C84.81 158.69 78.99 130.91 92.2 109.96C92.41 109.63 92.61 109.29 92.83 108.96C106.87 87.9005 135.32 82.2105 156.38 96.2505C177.11 110.07 182.93 137.85 169.72 158.8C169.51 159.13 169.31 159.47 169.09 159.8ZM191.33 202.16L184.98 197.92L197.69 178.86L194.51 176.74L181.8 195.8L175.45 191.56L188.16 172.5L200.87 153.44L207.22 157.68L194.51 176.74L197.69 178.86L210.4 159.8L216.75 164.04L204.04 183.1L207.22 185.22L219.93 166.16L226.28 170.4L213.57 189.46L200.86 208.52L194.51 204.28L207.22 185.22L204.04 183.1L191.33 202.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1321 72.9496L54.7158 111.074L61.0727 115.312L86.489 77.1875L80.1321 72.9496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6028 66.5971L45.1865 104.722L51.5434 108.96L76.9597 70.835L70.6028 66.5971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0589 60.2465L35.6426 98.3711L41.9994 102.609L67.4158 64.4844L61.0589 60.2465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.928 166.144L207.22 185.206L213.577 189.444L226.285 170.382L219.928 166.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.87 153.433L188.162 172.495L194.519 176.733L207.227 157.671L200.87 153.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 178.86L184.989 197.922L191.346 202.16L204.054 183.097L197.697 178.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.159 172.501L175.451 191.563L181.808 195.801L194.516 176.739L188.159 172.501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.217 185.212L194.509 204.274L200.866 208.512L213.574 189.45L207.217 185.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4 159.785L197.691 178.848L204.048 183.086L216.756 164.023L210.4 159.785Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39 96.25C135.33 82.21 106.88 87.9 92.8398 108.96C99.8598 98.43 114.08 95.59 124.61 102.61C135.14 109.63 137.98 123.85 130.96 134.38C137.98 123.85 152.2 121.01 162.73 128.03C172.93 134.83 175.92 148.39 169.71 158.81C182.92 137.86 177.1 110.08 156.37 96.26L156.39 96.25Z",
    fill: "#CD2D3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74 128.02C152.21 121 137.99 123.85 130.97 134.37C123.95 144.9 109.73 147.74 99.2004 140.72C89.0004 133.92 86.0104 120.36 92.2204 109.94C79.0104 130.89 84.8304 158.67 105.56 172.49C126.62 186.53 155.07 180.84 169.11 159.78C169.33 159.45 169.53 159.11 169.74 158.78C175.94 148.37 172.96 134.8 162.76 128L162.74 128.02Z",
    fill: "#134A9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2004 140.73C109.73 147.75 123.95 144.9 130.97 134.38C137.99 123.85 135.14 109.63 124.62 102.61C114.1 95.5898 99.8704 98.4398 92.8504 108.96C92.6304 109.29 92.4304 109.63 92.2204 109.96C86.0204 120.37 89.0004 133.94 99.2004 140.74V140.73Z",
    fill: "#CD2D3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5444 159.787L45.1875 164.025L57.8957 183.088L64.2525 178.85L51.5444 159.787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0063 166.148L35.6494 170.386L61.0657 208.51L67.4226 204.272L42.0063 166.148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0746 153.44L54.7178 157.678L80.1341 195.802L86.491 191.564L61.0746 153.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2446 178.862L57.8877 183.1L70.5959 202.162L76.9527 197.924L64.2446 178.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34 66.5853L184.983 70.8232L210.4 108.948L216.757 104.71L191.34 66.5853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.802 72.9486L175.445 77.1865L188.153 96.2488L194.51 92.0109L181.802 72.9486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.582 79.3021L207.226 83.54L219.934 102.602L226.291 98.3644L213.582 79.3021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.869 60.2357L194.512 64.4736L207.22 83.5359L213.577 79.298L200.869 60.2357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.51 92.0072L188.153 96.2451L200.861 115.307L207.218 111.07L194.51 92.0072Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_2425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.38,
    height: 259.38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrFlag);
export default __webpack_public_path__ + "static/media/krFlag.fb0468dee4af4c00249c20c26d11ead7.svg";
export { ForwardRef as ReactComponent };